var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgH(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.432 14C3.19733 14 3 13.92 2.84 13.76C2.68 13.6 2.6 13.4027 2.6 13.168V2.336C2.6 2.09067 2.68 1.89333 2.84 1.744C3 1.584 3.19733 1.504 3.432 1.504C3.67733 1.504 3.87467 1.584 4.024 1.744C4.184 1.89333 4.264 2.09067 4.264 2.336V6.928H11.688V2.336C11.688 2.09067 11.768 1.89333 11.928 1.744C12.088 1.584 12.2853 1.504 12.52 1.504C12.7653 1.504 12.9627 1.584 13.112 1.744C13.2613 1.89333 13.336 2.09067 13.336 2.336V13.168C13.336 13.4027 13.2613 13.6 13.112 13.76C12.9627 13.92 12.7653 14 12.52 14C12.2853 14 12.088 13.92 11.928 13.76C11.768 13.6 11.688 13.4027 11.688 13.168V8.4H4.264V13.168C4.264 13.4027 4.184 13.6 4.024 13.76C3.87467 13.92 3.67733 14 3.432 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH);
export default __webpack_public_path__ + "static/media/H.9f79d262.svg";
export { ForwardRef as ReactComponent };